<template>
  <div class="col-md-4 col-xs-12">
    <div class="bg-blue-grey-100 p-30 font-size-14 admin-package-box clearfix" v-if="!hasDiscount && !showDiscountForm">
      <div class="counter counter-md text-xs-left">
        <div class="counter-label text-uppercase m-b-5">Discount</div>
        <span class="counter-number">There are no Discount</span>
        <div class="counter-label text-uppercase m-b-5 m-t-20 clearfix">
          <button type="button"
            class="btn btn-primary btn-outline"
            v-if="!team.has_reseller"
            v-on:click="toggleDiscountForm">Add Discount
          </button>
        </div>
      </div>
    </div>
    <div class="bg-blue-grey-100 p-30 admin-package-box font-size-14 clearfix" v-else-if="showDiscountForm">
      <form autocomplete="off" v-on:submit.prevent="onSubmitDiscountForm">
        <div class="row">
          <alert v-show="showAlert"
            alertClass="m-b-25 alert-dismissible"
            type="danger"
            iconClass="md-close">
            <span>{{errorResponse}}</span>
          </alert>
          <form-group formGroupClass="form-group col-md-12" v-bind:error="formErrors.first('percent')">
            <label class="form-control-label">Discount Percent</label>
            <div class="input-group">
              <input type="number" class="form-control" id="percent" autocomplete="off" v-model="currentDiscount.percent">
              <span class="input-group-addon">%</span>
            </div>
          </form-group>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button type="submit" class="btn btn-success pull-xs-left">
              Update Discount
            </button>
          </div>
          <div class="col-md-6">
            <button type="button" class="btn btn-link pull-xs-right" v-on:click="cancleDiscountForm">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="bg-blue-grey-100 p-30 font-size-14 clearfix" v-else>
      <div class="counter counter-md text-xs-left">
        <div class="counter-label text-uppercase m-b-5">Discount</div>
        <span class="counter-number">{{currentDiscount.percent}} %</span>
        <div class="counter-label m-b-5 m-t-20">This team will be apply with this credit.</div>
        <!--div class="counter-label m-b-5">Last added: 1 Mar 2017 20:05</div-->
        <div class="counter-label text-uppercase m-b-5 m-t-20 clearfix">
          <button
            type="button"
            class="btn btn-primary"
            v-if="!team.has_reseller"
            v-on:click="toggleDiscountForm">Change discount
          </button>
          <button
            type="button"
            class="btn btn-link grey-100 pull-xs-right"
            v-if="!team.has_reseller"
            v-on:click="removeDiscount">Remove
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import Alert from 'components/Alert';
import FormGroup from 'components/forms/FormGroup';

export default {
  components: {
    Alert,
    FormGroup,
  },
  props: {
    team: {
      type: Object,
    },
  },
  watch: {
    'currentDiscount.percent': function() {
      if (this.formErrors.has('percent')) {
        this.formErrors.remove('percent');
      }
    },
    'currentDiscount.description': function() {
      if (this.formErrors.has('description')) {
        this.formErrors.remove('description');
      }
    },
  },
  computed: {
    hasDiscount: function() {
      return (this.team.discount > 0);
    },
  },
  created: function() {
    this.validator = new Validator();
    this.validator.attach('percent', 'required|between:0,100', { prettyName: 'discount percent' });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  mounted: function() {
    if (this.team && this.team.discount) {
      this.currentDiscount.percent = this.team.discount;
    }
  },
  data: function() {
    return {
      validator: null,
      formErrors: null,
      showAlert: false,
      errorResponse: null,
      showDiscountForm: false,
      currentDiscount: {
        percent: 0,
        description: null,
      },
    };
  },
  methods: {
    onSubmitDiscountForm: function() {
      // hide alert
      this.showAlert = false;

      this.validator.validateAll({
        percent: this.currentDiscount.percent,
      })
      .then(() => {
        return this.updateDiscount(this.currentDiscount.percent);
      })
      .then(() => {
        this.showAlert = false;

        this.toggleDiscountForm();

        this.team.discount = this.currentDiscount.percent;
      })
      .catch((error) => {
        if (error.response) {
          this.showAlert = true;
          this.errorResponse = this.$t('admin.billing.discount.response.failed');
        }
      });
    },
    toggleDiscountForm: function() {
      this.showDiscountForm = !this.showDiscountForm;
    },
    cancleDiscountForm: function() {
      this.currentDiscount.percent = this.team.discount;
      this.toggleDiscountForm();
    },
    updateDiscount: function (percent) {
      return axios.post(`/api/teams/${this.team.namespace}/discount`, {
        discount: percent,
      });
    },
    removeDiscount: function() {
      this.updateDiscount(0)
      .then(() => {
        this.currentDiscount.percent = 0;
        this.team.discount = 0;
      })
      .catch(() => {});
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DiscountPackage.vue?1c0f1a27